import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const TopNav = () => {
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // State for hamburger menu
    const [domainInput, setDomainInput] = useState("");

    const scrollToSection = (id: string) => {
        const section = document.getElementById(id);
        if (section) {
            const rect = section.getBoundingClientRect();
            const scrollOffset = -250;
            const finalScrollPosition = window.scrollY + rect.top + scrollOffset;

            window.scrollTo({
                top: finalScrollPosition,
                behavior: "smooth",
            });
        }
        setIsMenuOpen(false); // Close the menu after scrolling
    };

    const toggleModal = () => {
        setIsModalOpen((prev) => !prev);
        setIsMenuOpen(false);
    };

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDomainInput(e.target.value);
    };

    const handleFormSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (domainInput.trim()) {
            const constructedUrl = `https://${domainInput.trim()}.gr360.club`;
            window.open(constructedUrl, "_blank");
        } else {
            alert("Please enter a valid domain name.");
        }
    };

    const navigateHome = () => {
        window.location.href = '/';
    };

    const isLegalPage = ['/terms-of-service', '/privacy-policy', '/policies/privacy', '/delete-account'].includes(location.pathname);

    return (
        <>
            <nav className="top-nav">
                <button className="hamburger" onClick={toggleMenu}>
                    <span className="material-symbols-outlined">
                        {isMenuOpen ? "close" : "menu"}
                    </span>
                </button>
                <ul className={`menu ${isMenuOpen ? "open" : ""}`}>
                    {isLegalPage ? (
                        <>
                            <li>
                                <span className="material-symbols-outlined">home</span>
                                <button onClick={navigateHome}>Home</button>
                            </li>
                            <li>
                                <span className="material-symbols-outlined">sms</span>
                                <button onClick={() => scrollToSection("contact-us")}>
                                    Contact Us
                                </button>
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <span className="material-symbols-outlined">sdk</span>
                                <button onClick={() => scrollToSection("software")}>
                                    Software
                                </button>
                            </li>
                            <li>
                                <span className="material-symbols-outlined">payments</span>
                                <button onClick={() => scrollToSection("pricing")}>
                                    Pricing
                                </button>
                            </li>
                            <li>
                                <span className="material-symbols-outlined">sports_soccer</span>
                                <button onClick={() => scrollToSection("what-we-do")}>
                                    What We Do
                                </button>
                            </li>
                            <li>
                                <span className="material-symbols-outlined">face</span>
                                <button onClick={() => scrollToSection("about-us")}>
                                    About Us
                                </button>
                            </li>
                            <li>
                                <span className="material-symbols-outlined">sms</span>
                                <button onClick={() => scrollToSection("contact-us")}>
                                    Contact Us
                                </button>
                            </li>
                            <li>
                                <span className="material-symbols-outlined">login</span>
                                <button onClick={toggleModal}>Portal</button>
                            </li>
                        </>
                    )}
                </ul>
            </nav>

            {isModalOpen && (
                <div className="modal-overlay" onClick={toggleModal}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="close-button" onClick={toggleModal}>
                            ×
                        </button>
                        <h4>
                            <span className="material-symbols-outlined">web</span> Enter Your Domain
                        </h4>
                        <p>
                            This would be <strong>your club name</strong>.gr360.club
                        </p>
                        <form onSubmit={handleFormSubmit}>
                            <div>
                                <label>Domain:</label>
                                <input
                                    type="text"
                                    name="domain"
                                    placeholder="Your Club Name"
                                    value={domainInput}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <button type="submit" className="login">
                                Login
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default TopNav;
